import React, { useState } from 'react'
import LoanUtilityMain from './newloanutility'
import ProcessingFee from './ProcessingFee'
import ProductMain from './ProductMain'
import Product from './ProductMainnew'
import ReferalMain from './ReferalSection/Main'
import { Company_DATA, CheckFunction } from '../../../../../layouts/MainTenantconfig'
export default function configMain({ admin }) {
    const tenant = CheckFunction();
    const [tabs, setabs] = useState('loan')
    const handletabs = (type) => {
        setabs(type)
    }
    return (
        <>
            <div className="LoanUtility">

                <div className="tabs">
                    <div className={`tab ${tabs === 'loan' ? 'active' : ''}`} onClick={() => handletabs('loan')}>
                        <h5>Loan Utility</h5>
                    </div>
                    <div className={`tab ${tabs === 'processing' ? 'active' : ''}`} onClick={() => handletabs('processing')}>
                        <h5>Processing Fee</h5>
                    </div>
                    <div className={`tab ${tabs === 'product' ? 'active' : ''}`} onClick={() => handletabs('product')}>
                        <h5>Product</h5>
                    </div>
                    {
                        tenant?.COMPANY_NAME == Company_DATA?.ABHICASH ?
                            <div className={`tab ${tabs === 'Referal' ? 'active' : ''}`} onClick={() => handletabs('Referal')}>
                                <h5>Referral</h5>
                            </div>
                            : ''}
                </div>

                {
                    tabs === 'loan' ?
                        <LoanUtilityMain />
                        : ''}
                {
                    tabs === 'processing' ?
                        <ProcessingFee />
                        : ''}
                {
                    tabs === 'product' ?
                        // <ProductMain />
                        <Product />
                        : ''}
                {
                    tabs === 'Referal' ?
                        <ReferalMain admin={admin} />
                        : ''}
            </div>
        </>
    )
}
